// import React from "react";
// import OutputString from "./type/OutputString";
// import OutputDate from "./type/OutputDate";
// import OutputBoolean from "./type/OutputBoolean";
// import OutputImage from "./type/OutputImage";
// import OutputPointer from "./type/OutputPointer";

// const outputComponents = {
//   Email: OutputString,
//   String: OutputString,
//   Text: OutputString,
//   Number: OutputString,
//   Tel: OutputString,
//   Enum: OutputString,
//   Boolean: OutputBoolean,
//   Date: OutputDate,
//   Image: OutputImage,
//   Pointer: OutputPointer,
// };

// function OutputFactory({ type, _type, field, object, ...options }) {
//   console.log("Type", type, "field", field, "object", object);
//   const Component = outputComponents[_type] || outputComponents[type]; // Check _type first, fallback to type
//   if (Component) {
//     return <Component field={field} object={object} {...options} />;
//   }
//   if (type === "Component") {
//     return object[field];
//   }
//   return null;
// }

// export default OutputFactory;
import React from "react";
import OutputString from "./type/OutputString";
import OutputDate from "./type/OutputDate";
import OutputBoolean from "./type/OutputBoolean";
import OutputImage from "./type/OutputImage";
import OutputPointer from "./type/OutputPointer";

const outputComponents = {
  Email: OutputString,
  String: OutputString,
  Text: OutputString,
  Number: OutputString,
  Tel: OutputString,
  Enum: OutputString,
  Boolean: OutputBoolean,
  Date: OutputDate,
  Image: OutputImage,
  Pointer: OutputPointer,
};

function OutputFactory({ type, _type, field, object, ...options }) {
  const Component = outputComponents[_type] || outputComponents[type]; // Check _type first, fallback to type

  // Apply left alignment for specific fields
  const isNumericField =
    field === "systemCounts" || field === "actualCounts" || field === "cost";
  const style = isNumericField ? { textAlign: "Right", color: "black" } : {};

  if (Component) {
    return (
      <div style={style}>
        <Component field={field} object={object} {...options} />
      </div>
    );
  }
  if (type === "Component") {
    return <div style={style}>{object[field]}</div>;
  }
  return null;
}

export default OutputFactory;
